import React from 'react';
import { ManualPartnerCharge } from './ManualPartnerCharge';
import { ReportGeneration } from './ReportGeneration';
import { LinkInvoicesWithStores } from './LinkInvoicesWithStores';
import { ContentSection } from '../../components/Layout/ContentSection';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function FinancePage() {
  useDocumentTitle('PageTitles:finance');

  return (
    <ContentSection title="Finance" collapsable={false}>
      <ManualPartnerCharge />
      <br />
      <br />
      <ReportGeneration />
      <br />
      <br />
      <LinkInvoicesWithStores />
    </ContentSection>
  );
}
